// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/container_sections.css
// module id = VObN
// module chunks = 1